module.exports = __webpack_public_path__ + "img/tarj3-7.686a985f.svg";